import React, { useEffect } from 'react';
import * as yup from 'yup';
import TranslatedCopy from '../../../intl/translated-copy';
import cx from 'classnames';
import {
  func,
  object,
} from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { connect } from 'react-redux';
import { withWindow } from '../../../decorators/window';
import taxDataMainOptions, { getNationalForeignData } from '../../../constants/billingDataMainOptions';
import Tooltip from '../tooltip';
import { getStampingBillingAction, setBillingDataAction } from '../../../../redux/actions';

const mapStateToProps = (state) => ({
  checkinReservation: state.checkinReservation,
  helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
  singleBilling: state.singleBilling,
});

const ModalFormBilling = ({
  checkinReservation,
  dispatch,
  helperTraslatedCopy,
  singleBilling,
}) => {
  const schema = yup.object().shape({
    accountingKey: yup.string().length(6, helperTraslatedCopy.getFormatMessageFromcopyId('MYB_ACCOUNTING_KEY_DIGITS')).when(['ineComplement'], ([ineComplement], schema) => {
      return ineComplement ? schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_ACCOUNTING_KEY')) : schema.optional();
    }),
    ambit: yup.string().when(['ineComplement', 'processType'], ([ineComplement, processType], schema) => { 
      return ineComplement && (processType === 'Campaña' || processType === 'Precampaña') ? schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_AMBIT_REQUIRED')) : schema.optional(); 
    }),
    billingMail: yup.string().required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_EMAIL_REQUIRED')).matches(/^[\w\-\.]+@([\w-]+\.)+[\w-]{2,}$/, helperTraslatedCopy.getFormatMessageFromcopyId('MYB_EMAIL_INVALID_INVOICE')),
    billingPostalCode: yup.string().when('typeOfRfc', ([typeOfRfc], schema) => {
      return typeOfRfc === '' || typeOfRfc === 'R03' || typeOfRfc === 'R04' ? schema.optional() : schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_ZIP_CODE_REQUIRED')).matches(/^\d{5}$/, helperTraslatedCopy.getFormatMessageFromcopyId('MYB_ZIP_CODE_VALID'));
    }),
    cfdiUse: yup.string().when('typeOfRfc', ([typeOfRfc], schema) => {
      return typeOfRfc === '' || typeOfRfc === 'R03' || typeOfRfc === 'R04' ? schema.optional() : schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_USE_OF_CFDI'));
    }),
    committeeType: yup.string().when(['ineComplement', 'processType'], ([ineComplement, processType], schema) => {
      return ineComplement && processType === 'Ordinario' ? schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_COMMITTEE_TYPE')) : schema.optional();
    }),
    entity: yup.string().when(['ineComplement', 'processType', 'committeeType'], ([ineComplement, processType, committeeType], schema) => {
      return ineComplement && ((processType === 'Ordinario' && committeeType === 'Ejecutivo Estatal') || processType === 'Campaña' || processType === 'Precampaña' ) ? schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_ENTITY')) : schema.optional();
    }),
    ineComplement: yup.boolean().optional(),
    // paymentType:yup.string().required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_PAYMENT_TYPE_REQUIRED')),
    processType: yup.string().when('ineComplement', ([ineComplement], schema) => {
      return ineComplement ? schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_TYPE_PROCESS')) : schema.optional();
    }),
    rfc:  yup.string().when('typeOfRfc', ([typeOfRfc], schema) => {
      return (typeOfRfc === '' || (typeOfRfc === 'R03' || typeOfRfc === 'R04')) 
        ? schema.optional() 
        : yup.string().required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_RFC_REQUIRED'))
          .matches(/^([A-ZÑ&]{3,4})(\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))([A-Z\d]{2})([A\d])$/, 
            helperTraslatedCopy.getFormatMessageFromcopyId('MYB_RFC_INVALID'));
    }),
    socialReason: yup.string().required(helperTraslatedCopy.getFormatMessageFromcopyId('PAX_VALIDATION_BUSINESS_NAME')),
    taxRegime: yup.string().when('typeOfRfc', ([typeOfRfc], schema) => {
      return (typeOfRfc === '' || (typeOfRfc === 'R03' || typeOfRfc === 'R04')) ? schema.optional()
        : schema.required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_TAX_REGIME'));
    }),
    typeOfRfc: yup.string().required(helperTraslatedCopy.getFormatMessageFromcopyId('MYB_TYPE_RFC')),
  });

  let reservationEmail = checkinReservation?.responseCheckInReservation?.passengersCollection?.passengers.find(pax => pax?.passengerInfo?.emails[0] !== '' && pax?.passengerInfo?.emails[0] !== null && pax?.passengerInfo?.emails[0] !== undefined);
  reservationEmail = reservationEmail !== undefined ? reservationEmail?.passengerInfo?.emails[0] : helperTraslatedCopy.getFormatMessageFromcopyId('PRO_WEB_PROFILE_INFO_NONE');  

  return (
    <Formik
      initialValues={{ 
        accountingKey: '',
        ambit:'',
        billingMail: '',
        billingPostalCode: '',
        cfdiUse: '',
        committeeType: '',
        entity: '',
        ineComplement: false,
        // paymentType:'',
        processType: '',
        rfc: '',
        socialReason: '',
        taxRegime: '',
        typeOfRfc: '',
      }}
      onSubmit={(values) => {
        const isR03R04 = values?.typeOfRfc === 'R04' || values?.typeOfRfc === 'R03' ? true : false;
        const typeOfRfcOptions = taxDataMainOptions['RFC_TYPE'];
        const tipoRfcDescripcion = typeOfRfcOptions.find(option => option?.value === values?.typeOfRfc);

        let taxRegimeOptions = [];
        if (values?.typeOfRfc === 'R01') {
          taxRegimeOptions = taxDataMainOptions['TAX_REGIME_NATURAL_PERSON'];
        } else if (values?.typeOfRfc === 'R02') {
          taxRegimeOptions = taxDataMainOptions['TAX_REGIME_MORAL_PERSON'];
        } else if (isR03R04) {
          taxRegimeOptions = taxDataMainOptions['NO_TAX_OBLIGATIONS'];
        }
        const regimenDescripcion = taxRegimeOptions.find(option => isR03R04 ? option?.value === '616' : option?.value === values?.taxRegime);
        const defaultValues = getNationalForeignData(values?.typeOfRfc ? values.typeOfRfc : 'R03');

        const obj = {
          regimenDescripcion: `${ regimenDescripcion?.value } - ${ regimenDescripcion?.copyID }`,
          singleBilling: singleBilling,
          tipoRfcDescripcion: tipoRfcDescripcion?.sendValue,
          transactionId: checkinReservation?.responseCheckInReservation?.transactionId,
          values: { 
            ...values,
            billingPostalCode: isR03R04 ? defaultValues.postalCode : values.billingPostalCode,
            cfdiUse: isR03R04 ? defaultValues.cfdiUse : values.cfdiUse,
            rfc: isR03R04 ? defaultValues.rfc : values.rfc,
            taxRegime: isR03R04 ? defaultValues.taxRegime : values.taxRegime,

          },
        };
        dispatch(setBillingDataAction(obj.values));
        dispatch(getStampingBillingAction(obj));
      }}
      validationSchema={ schema }
    >
      { (formikData) => {
        const {
          dirty,
          errors,
          handleChange,
          setFieldTouched,
          setFieldValue,
          submitForm,
          touched,
          values,
        } = formikData;
        const hasErrors = Object.keys(errors).length !== 0;
        const formTouched = Object.keys(touched).length !== 0;

        const handleInputChange = (e) => {
          const isAutofilled = e.target.matches(':-webkit-autofill');
          if (isAutofilled) {
            setFieldTouched(e.target.name, true);
          }
          handleChange(e);
        };

        const handleChangeRFCType = (e) => {          
          if (e.target.value === 'R03' || e.target.value === 'R04') {
            const defaultValues = getNationalForeignData(e.target.value);

            setFieldValue('socialReason', defaultValues.socialReason);
          } else {
            setFieldValue('socialReason', '');
          }

          handleChange(e);
        };

        useEffect(() => {
          if ( values.ineComplement === false ) { // INE Complement is false and we need to erase the ine fields 
            setFieldValue('processType', '');
            setFieldTouched('processType', false);
            setFieldValue('committeeType', '');
            setFieldTouched('committeeType', false);
            setFieldValue('entity', '');
            setFieldTouched('entity', false);
            setFieldValue('accountingKey', '');
            setFieldTouched('accountingKey', false);
          }
        }, [values.ineComplement]);
        
        useEffect(() => {
          if (values?.processType === 'Ordinario' && values?.committeeType != 'Ejecutivo Estatal') {
            setFieldValue('entity', '');
            setFieldTouched('entity', false);
          }
        }, [values.committeeType, values.processType]);
        
        const typeOfRfcClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.typeOfRfc && errors.typeOfRfc,
          'inputCorrect': touched.typeOfRfc && !errors.typeOfRfc,
        });

        const rfcClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.rfc && errors.rfc,
          'inputCorrect': touched.rfc && !errors.rfc,
        });

        const socialReasonClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.socialReason && errors.socialReason,
          'inputCorrect': touched.socialReason && !errors.socialReason,
        });

        const billingPostalCodeClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.billingPostalCode && errors.billingPostalCode,
          'inputCorrect': touched.billingPostalCode && !errors.billingPostalCode,
        });

        const taxRegimeClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.taxRegime && errors.taxRegime,
          'inputCorrect': touched.taxRegime && !errors.taxRegime,
        });

        const cfdiUseClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.cfdiUse && errors.cfdiUse,
          'inputCorrect': touched.cfdiUse && !errors.cfdiUse,
        });

        const billingMailClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.billingMail && errors.billingMail,
          'inputCorrect': touched.billingMail && !errors.billingMail,
        });

        // const paymentTypeClasses = cx({
        //   'BillingModal-form-formOption': true,
        //   'inputError': touched.paymentType && errors.paymentType,
        //   'inputCorrect': touched.paymentType && !errors.paymentType,
        // });

        const processTypeClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.processType && errors.processType,
          'inputCorrect': touched.processType && !errors.processType,
        });

        const ambitTypeClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.ambit && errors.ambit,
          'inputCorrect': touched.ambit && !errors.ambit,
        });

        const committeeTypeClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.committeeType && errors.committeeType,
          'inputCorrect': touched.committeeType && !errors.committeeType,
        });

        const entityClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.entity && errors.entity,
          'inputCorrect': touched.entity && !errors.entity,
        });

        const accountingKeyClasses = cx({
          'BillingModal-form-formOption': true,
          'inputError': touched.accountingKey && errors.accountingKey,
          'inputCorrect': touched.accountingKey && !errors.accountingKey,
        });

        // const paymentTypeIconClasses = cx({
        //   'Icon': true,
        //   'Icon--check': touched.paymentType && !errors.paymentType,
        //   'Icon--arrowSmallDown': !touched.paymentType || (touched.paymentType && errors.paymentType),
        // });

        const ambitIconClasses = cx({
          'Icon': true,
          'Icon--check': touched.ambit && !errors.ambit,
          'Icon--arrowSmallDown': !touched.ambit || (touched.ambit && errors.ambit),
        });


        const typeOfRfcEmptyOrR3OrR4 = values?.typeOfRfc === '' || (values?.typeOfRfc === 'R03' || values?.typeOfRfc === 'R04');

        // BillingPostalCode
        const billingPostalCodeDisable = typeOfRfcEmptyOrR3OrR4;
        if (typeOfRfcEmptyOrR3OrR4 && (values?.billingPostalCode !== '' || touched?.billingPostalCode)) {
          setFieldValue('billingPostalCode', '');
          setFieldTouched('billingPostalCode', false);
        }

        // typeOfRfc
        const taxRegimeDisable = typeOfRfcEmptyOrR3OrR4;
        if (taxRegimeDisable && (values?.rfc !== '' || touched?.rfc)) {
          setFieldValue('rfc', '');
          setFieldTouched('rfc', false);
        }
        const typeOfRfcOptions = taxDataMainOptions['RFC_TYPE'];

        // taxRegime
        let taxRegimeOptions = [];
        if (values?.typeOfRfc === 'R01') {
          taxRegimeOptions = taxDataMainOptions['TAX_REGIME_NATURAL_PERSON'];
        } else if (values?.typeOfRfc === 'R02') {
          taxRegimeOptions = taxDataMainOptions['TAX_REGIME_MORAL_PERSON'];
        } else if (values?.typeOfRfc === 'R03' || values?.typeOfRfc === 'R04') {
          taxRegimeOptions = taxDataMainOptions['NO_TAX_OBLIGATIONS'];
        }
        const optionsAllowedOnBoth = ['610', '626'];
        const universalOptionSelected = optionsAllowedOnBoth.some(optAllowed => optAllowed === values?.taxRegime);
        if ((values?.typeOfRfc === 'R01' || values?.typeOfRfc === 'R02') && !universalOptionSelected) {
          if ((values?.typeOfRfc !== 'R01' && values?.taxRegime !== '' && (taxDataMainOptions['TAX_REGIME_NATURAL_PERSON'] || []).some((possibleOption) => possibleOption?.value === values?.taxRegime))
            || (values?.typeOfRfc !== 'R02' && values?.taxRegime !== '' && (taxDataMainOptions['TAX_REGIME_MORAL_PERSON'] || []).some((possibleOption) => possibleOption?.value === values?.taxRegime))) {
            setFieldValue('taxRegime', '');
            setFieldTouched('taxRegime', false);
          }
        } else if (typeOfRfcEmptyOrR3OrR4 && (values?.taxRegime !== '' || touched?.taxRegime)) {
          setFieldValue('taxRegime', '');
          setFieldTouched('taxRegime', false);
        }

        // CDFI
        const CFDIDisable = typeOfRfcEmptyOrR3OrR4 || (!typeOfRfcEmptyOrR3OrR4 && values?.taxRegime === '');
        let CFDIOptions = [];
        if (!CFDIDisable) {
          let test = [];
          if (values?.typeOfRfc === 'R01') {
            test = taxDataMainOptions['TAX_REGIME_NATURAL_PERSON'];
          } else if (values?.typeOfRfc === 'R02') {
            test = taxDataMainOptions['TAX_REGIME_MORAL_PERSON'];
          }
          const testItem = test.find(item => item.value === values?.taxRegime);
          CFDIOptions = testItem?.CFDiUses;
          const selectedInfoNotOnList = values?.cfdiUse !== '' ? !CFDIOptions.find(opt => opt?.value === values?.cfdiUse) : false;
          if (selectedInfoNotOnList) {
            setFieldValue('cfdiUse', '');
            setFieldTouched('cfdiUse', false);
          }
        } else if (values?.typeOfRfc === 'R03' || values?.typeOfRfc === 'R04') {
          CFDIOptions = [taxDataMainOptions['CFDI'].find(x=>x.value === 'S01')];
        }
        if ((typeOfRfcEmptyOrR3OrR4 || CFDIDisable) && (values?.cfdiUse !== '' || touched?.cfdiUse)) {
          setFieldValue('cfdiUse', '');
          setFieldTouched('cfdiUse', false);
        }

        // paymentType options
        // const paymentTypeOptions = taxDataMainOptions['PAYMENT_TYPE'];

        // processType
        const processTypeOptions = taxDataMainOptions['PROCESSTYPE'];

        // ambit
        const ambitOptions = taxDataMainOptions['AMBIT'];
        const ambitDisable = values?.processType !== 'Precampaña' && values?.processType !== 'Campaña';
        if (ambitDisable && (values?.ambit !== '' || touched?.ambit)) {
          setFieldValue('ambit', '');
          setFieldTouched('ambit', false);
        }

        // committeeType
        const committeeTypeOptions = taxDataMainOptions['COMMITTEE_TYPE'];
        const committeeTypeDisable = values?.processType !== 'Ordinario';
        if (committeeTypeDisable && (values?.committeeType !== '' || touched?.committeeType)) {
          setFieldValue('committeeType', '');
          setFieldTouched('committeeType', false);
        }

        // entity
        const entityOptions = taxDataMainOptions['ENTITY'];
        const entityDisable = (values?.processType === 'Ordinario' && values?.committeeType !== 'Ejecutivo Estatal') || values?.processType === '';
        if (entityDisable && values?.entity !== '') {
          setFieldValue('entity', '');
          setFieldTouched('entity', false);
        }

        // accountingKey
        const accountingKeyDisable = !(values?.committeeType === 'Ejecutivo Nacional' || (values?.committeeType === 'Ejecutivo Estatal' && values?.entity !== '') || values.entity !== '' ); 
        if (accountingKeyDisable && (values?.accountingKey !== '' || touched?.accountingKey)) {
          setFieldValue('accountingKey', '');
          setFieldTouched('accountingKey', false);
        }

        return (
          <>
            <div className='BillingModal-content'>
              <div className='BillingModal-content-subtitle'>
                <TranslatedCopy copyID='MYB_COMPLETE_THE_FIELDS_LIKE_TAX_ID' />
              </div>
              <div className='BillingModal-content-flightInfo'>
                <div className='BillingModal-content-flightInfo-halfSection'>
                  <TranslatedCopy
                    className='BillingModal-content-flightInfo-halfSection-text'
                    copyID='MYB_RESERVATION_KEY'
                  />
                  <span className='BillingModal-content-flightInfo-halfSection-text-bold'>{` ${ checkinReservation?.responseCheckInReservation?.reservationCode }`}</span>
                </div>
                <div className='BillingModal-content-flightInfo-halfSection'>
                  <TranslatedCopy
                    className='BillingModal-content-flightInfo-halfSection-text'
                    copyID='MYB_EMAIL_WITH_POINTS'
                  />
                  <span className='BillingModal-content-flightInfo-halfSection-text-bold'>{`${ reservationEmail }`}</span>
                </div>
              </div>
              <Form className='BillingModal-form'>
                <div className={ typeOfRfcClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      copyID='MYB_RFC_TYPE'
                      tagName='label'
                    />
                    <Tooltip
                      copyID='MYB_SELECT_YOUR_RFC_TOOLTIP'
                      position={{
                        'small': 'right',
                        'medium': 'right',
                        'medium-high': 'right',
                        'large': 'right',
                      }}
                    />
                  </div>
                  <Field
                    as='select'
                    id='typeOfRfc'
                    name='typeOfRfc'
                    type='text'
                    onChange = {handleChangeRFCType}
                  >
                    { typeOfRfcOptions.map(option => ( 
                      <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>
                        { option?.copyID }
                      </option>
                    )
                    )}
                  </Field>
                  { (touched?.typeOfRfc && !errors?.typeOfRfc) ?
                    <span className='Icon Icon--check'/>
                    :
                    <span className='Icon Icon--arrowSmallDown' />
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='typeOfRfc'
                  />
                </div>
                <div className={ rfcClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      className={`${ typeOfRfcEmptyOrR3OrR4 ? 'disable' : '' }`}
                      copyID='MYB_RFC'
                      tagName='label'
                    />
                    <Tooltip
                      copyID='MYB_WRITE_YOUR_RFC_TOOLTIP'
                      position={{
                        'small': 'right',
                        'medium': 'right',
                        'medium-high': 'right',
                        'large': 'right',
                      }}
                    />
                  </div>
                  <Field
                    onChange= { (e) => handleInputChange(e) }
                    disabled={ typeOfRfcEmptyOrR3OrR4 }
                    id='rfc'
                    name='rfc'
                    type='text'
                    placeholder = {values?.typeOfRfc === 'R04' || values?.typeOfRfc === 'R03' ? getNationalForeignData(values.typeOfRfc).rfc : '' }
                  />
                  { (touched?.rfc && !errors?.rfc) &&
                    <span className='Icon Icon--check'/>
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='rfc'
                  />
                </div>
                <div className={ socialReasonClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      copyID='MYB_NAME_OR_SOCIAL_REASON'
                      tagName='label'
                    />
                  </div>
                  <Field
                    onChange= { (e) => handleInputChange(e) }
                    id='socialReason'
                    name='socialReason'
                    type='text'
                  />
                  { (touched?.socialReason && !errors?.socialReason) &&
                    <span className='Icon Icon--check'/>
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='socialReason'
                  />
                </div>
                <div className={ billingPostalCodeClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      className={`${ billingPostalCodeDisable ? 'disable' : '' }`}
                      copyID='MYB_POSTAL_CODE'
                      tagName='label'
                    />
                  </div>
                  <Field
                    disabled={ billingPostalCodeDisable }
                    id='billingPostalCode'
                    name='billingPostalCode'
                    onChange= { (e) => {
                      e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
                      handleInputChange(e);
                    } }
                    inputMode='numeric'
                    maxLength={ 5 }
                    type='text'
                    placeholder = {values?.typeOfRfc === 'R04' || values?.typeOfRfc === 'R03' ? getNationalForeignData(values.typeOfRfc).postalCode  : '' }

                  />
                  { (touched?.billingPostalCode && !errors?.billingPostalCode) &&
                    <span className='Icon Icon--check'/>
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='billingPostalCode'
                  />
                </div>
                <div className={ taxRegimeClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      className={`${ taxRegimeDisable ? 'disable' : '' }`}
                      copyID='MYB_BILLING_TAX_REGIME'
                      tagName='label'
                    />
                  </div>
                  <Field
                    as='select'
                    disabled={ taxRegimeDisable }
                    id='taxRegime'
                    name='taxRegime'
                    type='text'
                  >
                    { taxRegimeOptions.map(option => ( 
                      <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>{ option?.copyID }</option>)
                    )}
                  </Field>
                  { (touched.taxRegime && !errors.taxRegime) ?
                    <span className='Icon Icon--check'/>
                    :
                    <span className='Icon Icon--arrowSmallDown' />
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='taxRegime'
                  />
                </div>
                <div className={ cfdiUseClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      className={`${ CFDIDisable ? 'disable' : '' }`}
                      copyID='MYB_CFDI_USE'
                      tagName='label'
                    />
                  </div>
                  <Field
                    as='select'
                    id='cfdiUse'
                    name='cfdiUse'
                    type='text'
                    disabled={ CFDIDisable }
                  >
                    { CFDIOptions.map(option => ( 
                      <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>{ option?.copyID }</option>)
                    )}
                  </Field>
                  { (touched.cfdiUse && !errors.cfdiUse) ?
                    <span className='Icon Icon--check'/>
                    :
                    <span className='Icon Icon--arrowSmallDown' />
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='cfdiUse'
                  />
                </div>
                {/* <div className={ paymentTypeClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      copyID='MYB_PAYMENT_TYPE'
                      tagName='label'
                    />
                  </div>
                  <Field
                    as='select'
                    id='paymentType'
                    name='paymentType'
                    type='text'
                  >
                    { paymentTypeOptions.map(option => ( 
                      <option key={ option?.value } value={ option?.value === '000' ? '' : option?.copyID }>{ option?.copyID }</option>)
                    )}
                  </Field>
                  
                  <span className={ paymentTypeIconClasses }/>
          
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='paymentType'
                  />
                </div> */}
                <div className={ billingMailClasses }>
                  <div className='BillingForm-labelSection'>
                    <TranslatedCopy
                      copyID='MYB_MAIL_DIRECTION'
                      tagName='label'
                    />
                  </div>
                  <Field
                    onChange= { (e) => handleInputChange(e) }
                    id='billingMail'
                    name='billingMail'
                    type='text'
                  />
                  { (touched?.billingMail && !errors?.billingMail) &&
                    <span className='Icon Icon--check'/>
                  }
                  <ErrorMessage
                    className='error-message'
                    component='p'
                    name='billingMail'
                  />
                </div>
                <div className='BillingModal-form-formOption'>
                  <div className='IneSection'>
                    <label className='switch'>
                      <input type='checkbox' onClick={ () => setFieldValue('ineComplement', !values?.ineComplement) }/>
                      <span className='slider round'/>
                    </label>
                    <TranslatedCopy
                      className='IneSection-text'
                      copyID='MYB_ADD_INE_COMPLEMENT'
                      tagName='span'
                    />
                  </div>
                </div>
                { values?.ineComplement && // INE Complement fields
                  <>
                    <div className={ processTypeClasses }>
                      <div className='BillingForm-labelSection'>
                        <TranslatedCopy
                          copyID='MYB_PROCESS_TYPE_FACTURATION'
                          tagName='label'
                        />
                      </div>
                      <Field
                        as='select'
                        id='processType'
                        name='processType'
                        type='text'
                      >
                        { processTypeOptions.map(option => ( 
                          <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>{ option?.copyID }</option>)
                        )}
                      </Field>
                      { (touched.processType && !errors.processType) ?
                        <span className='Icon Icon--check'/>
                        :
                        <span className='Icon Icon--arrowSmallDown' />
                      }
                      <ErrorMessage
                        className='error-message'
                        component='p'
                        name='processType'
                      />
                    </div>

                    <div className={ ambitTypeClasses }>
                      <div className='BillingForm-labelSection'>
                        <TranslatedCopy
                          className={`${ ambitDisable ? 'disable' : '' }`}
                          copyID='MYB_AMBIT_FACTURATION'
                          tagName='label'
                        />
                      </div>
                      <Field
                        as='select'
                        id='ambit'
                        name='ambit'
                        type='text'
                        disabled={ ambitDisable }

                      >
                        { ambitOptions.map(option => ( 
                          <option key={ option?.value } value={ option?.value === '000' ? '' : option?.copyID }>{ option?.copyID }</option>)
                        )}
                      </Field>
                      <span className={ ambitIconClasses }/>

                      <ErrorMessage
                        className='error-message'
                        component='p'
                        name='ambit'
                      />
                    </div>

                    <div className={ committeeTypeClasses }>
                      <div className='BillingForm-labelSection'>
                        <TranslatedCopy
                          className={`${ committeeTypeDisable ? 'disable' : '' }`}
                          copyID='MYB_COMMITTEE_TYPE_FACTURATION'
                          tagName='label'
                        />
                      </div>
                      <Field
                        as='select'
                        disabled={ committeeTypeDisable }
                        id='committeeType'
                        name='committeeType'
                        type='text'
                      >
                        { committeeTypeOptions.map(option => ( 
                          <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>{ option?.copyID }</option>)
                        )}
                      </Field>
                      { (touched.committeeType && !errors.committeeType) ?
                        <span className='Icon Icon--check'/>
                        :
                        <span className='Icon Icon--arrowSmallDown' />
                      }
                      <ErrorMessage
                        className='error-message'
                        component='p'
                        name='committeeType'
                      />
                    </div>
                    <div className={ entityClasses }>
                      <div className='BillingForm-labelSection'>
                        <TranslatedCopy
                          className={`${ entityDisable ? 'disable' : '' }`}
                          copyID='MYB_ENTITY_FACTURATION'
                          tagName='label'
                        />
                      </div>
                      <Field
                        as='select'
                        disabled={ entityDisable }
                        id='entity'
                        name='entity'
                        type='text'
                      >
                        { entityOptions.map(option => ( 
                          <option key={ option?.value } value={ option?.value === '000' ? '' : option?.value }>{ option?.copyID }</option>)
                        )}
                      </Field>
                      { (touched.entity && !errors.entity) ?
                        <span className='Icon Icon--check'/>
                        :
                        <span className='Icon Icon--arrowSmallDown' />
                      }
                      <ErrorMessage
                        className='error-message'
                        component='p'
                        name='entity'
                      />
                    </div>
                    <div className={ accountingKeyClasses }>
                      <div className='BillingForm-labelSection'>
                        <TranslatedCopy
                          className={`${ accountingKeyDisable ? 'disable' : '' }`}
                          copyID='MYB_ACCOUNTING_KEY_BILLING'
                          tagName='label'
                        />
                      </div>
                      <Field
                        onChange= { (e) => handleInputChange(e) }
                        id='accountingKey'
                        disabled={ accountingKeyDisable }
                        name='accountingKey'
                        type='text'
                        maxLength={ 6 }
                      />
                      { (touched?.accountingKey && !errors?.accountingKey) &&
                        <span className='Icon Icon--check'/>
                      }
                      <ErrorMessage
                        className='error-message'
                        component='p'
                        name='accountingKey'
                      />
                    </div>
                  </>
                }
              </Form>
            </div>
            <div className='BillingModal-footer'>
              <button
                className='BillingModal-submitButton'
                disabled={ !(formTouched && dirty && !hasErrors) }
                onClick={ () => submitForm() }
                type='submit'
              >
                <TranslatedCopy copyID='MYB_BILL_FACTURATION'/>
              </button>
            </div>
          </>
        );
      }}
    </Formik>
  );
};

ModalFormBilling.propTypes = {
  dispatch: func.isRequired,
  helperTraslatedCopy: object.isRequired,
};

const ModalFormBillingStore = connect(mapStateToProps)(ModalFormBilling);
export default withWindow(ModalFormBillingStore);